import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Typography from '../../Typography';
import CheckboxCheckedIcon from '../../icons/CheckboxCheckedIcon';
import CheckboxUncheckedIcon from '../../icons/CheckboxUncheckedIcon';

const icons = {
  checked: CheckboxCheckedIcon,
  unchecked: CheckboxUncheckedIcon,
};

function CheckboxInput(props) {
  const { labelId, input, classes, className } = props;
  const Icon = icons[input.value ? 'checked' : 'unchecked'];
  return (
    <div className={classNames(className, classes.root)}>
      <label key={input.labelId} className={classes.itemRoot}>
        <input
          type="checkbox"
          checked={input.value}
          onChange={() => input.onChange(!input.value)}
          hidden
        />
        <Icon className={classNames(classes.icon, input.value && classes.checked)} />
        <Typography className={classes.optionLabel} type="caption">
          <FormattedMessage id={labelId} />
        </Typography>
      </label>
    </div>
  );
}

CheckboxInput.propTypes = {
  input: PropTypes.object.isRequired,
  labelId: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

CheckboxInput.defaultProps = {
  className: null,
};

const stylesheet = theme => ({
  root: {
    position: 'relative',
  },
  itemRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: [[theme.spacing.unit, 0]],
    cursor: 'pointer',
    borderRadius: 4,
    transition: `background-color ${theme.transitions.duration.shortest}ms`,
  },
  optionLabel: {
    marginLeft: theme.spacing.unit,
  },
  icon: {
    transition: `color ${theme.transitions.duration.short}ms`,
    '$itemRoot:hover &': {
      color: theme.palette.success[500],
    },
  },
  checked: {
    color: theme.palette.success[500],
    '$itemRoot:hover &': {
      color: theme.palette.success[300],
    },
  },
});

export default injectSheet(stylesheet)(CheckboxInput);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/CheckboxInput/CheckboxInput.js